import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { Modal } from '@citrus/modal';
import { PrimaryButton, SecondaryButton } from '@citrus/button';
import { Textarea } from '@citrus/input-textarea';


class OptOutConfirmationModal extends Component {

  render() {
    const handleDismiss = () => this.props.dismissOptOutModal(this.props.onDismissCallback);
    const body = typeof this.props.body === 'string' ? <p>{this.props.body}</p> : this.props.body;

    return (
      <Modal
        id="formOptOutReasonModal"
        headerText={this.props.headerText}
        open={this.props.visible || false}
        size={this.props.size}
        onCancel={handleDismiss}>
        <div>
          <div style={{ paddingBottom: '10px' }}>{body}</div>
          <Textarea
            id="formOptOutReason"
            label={`Opt-Out Reason`}
            value={this.props.formInstance.optOutReason || ''}
            onChange={(optOutReason) => this.props.setOptOutReason(optOutReason.value)}
            maxLength={250}
            placeholder={`Enter reason for opting out`} />
        </div>
        <Modal.Footer>
          <PrimaryButton disabled={this.props.confirmDisabled} onClick={() => { this.props.confirm(this.props.onConfirmCallback) }}>{this.props.confirmText}</PrimaryButton>
          <SecondaryButton onClick={handleDismiss}>{this.props.dismissText}</SecondaryButton>
        </Modal.Footer>
      </Modal>      
    )
  }

  static defaultProps = {
    size: 'small',
    confirmText: 'Opt Out',
    dismissText: 'Cancel'
  };

  static propTypes = {
    headerText: PropTypes.string.isRequired,
    body: PropTypes.node.isRequired,
    size: PropTypes.string,
    visible: PropTypes.bool,
    survey: PropTypes.object,
    optOutReason: PropTypes.string,
    onConfirmCallback: PropTypes.func.isRequired,
    onDismissCallback: PropTypes.func,
    dismissOptOutModal: PropTypes.func,
    confirm: PropTypes.func,
    confirmText: PropTypes.string,
    dismissText: PropTypes.string,
    setOptOutReason: PropTypes.func.isRequired,
  };
}

export default OptOutConfirmationModal;